// INSTANCES
import { reportsApiAxiosInstance } from '../instances/reportsApiAxiosInstance';

// TYPES
import { ContinueReportGenerationPayload } from '../types/reportsTypes';

export const reportsClient = {
  postContinueReportGeneration(payload: ContinueReportGenerationPayload) {
    return reportsApiAxiosInstance.post<void>('resume-report', payload);
  },
};
